// Put stuff in here that is widely used across the site.
//
// Features that are used only on a few pages, such as most
// view components, should be imported into individual packs.

import {mountOnId, mountOnDataBehavior} from 'shared'

import {
  CookieBanner,
  CookieBannerLink,
  PlatformAdminUI,
  RandomProjectHotkey,
  gaScrollTracking,
  SubscriptionToggle,
} from 'utils'

import {
  CounterWidget,
  TimerWidget,
  TimeAgo,
  PasswordStrengthMeter,
  PasswordReveal,
} from 'shared'

document.addEventListener("DOMContentLoaded", () => {
  new PlatformAdminUI()
  new RandomProjectHotkey()
  global.PlatformAdminUI = PlatformAdminUI

  mountOnId(CookieBanner, 'cookie-banner')
  mountOnDataBehavior(CookieBannerLink, 'cookie-banner-link')
  mountOnDataBehavior(TimeAgo, 'time_ago')
  mountOnDataBehavior(CounterWidget, 'counter-widget')
  mountOnDataBehavior(TimerWidget, 'timer-widget')
  mountOnDataBehavior(PasswordReveal, 'password_reveal')
  mountOnDataBehavior(PasswordStrengthMeter, 'password_strength')
  mountOnDataBehavior(SubscriptionToggle, 'subscription-toggle')
})

document.addEventListener('scroll', gaScrollTracking)
